<template>
  <div class="success-box">
    <div class="icon-box">
      <van-icon name="checked" color="#52c41a" size="60" />
    </div>
    <div class="info-box">
      <div class="info-line">
        <span class="label">{{$t('options.换绑成功')}}</span>
        <span class="value">{{ form.new_phone }}</span>
      </div>
    </div>
    <div style="margin: 16px;">
        <van-button
          block
          type="primary"
          size="large"
          @click="handleBack"
        >
          {{$t('options.返回首页')}}
        </van-button>
      </div>
  </div>
</template>

<script>
  export default {
    props: {
      form: {
        type: Object,
        default: () => ({
          phone: '',
          new_phone: '',
        }),
      }
    },
    methods: {
      handleBack () {
        this.$router.back();
      }
    }
  };
</script>

<style lang="less" scoped>
.success-box {
  width: 100%;
  margin-top: 10px;
  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
  }
  .info-box {
    display: flex;
    flex-direction: column;
    .info-line {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 8px;
      .label {
        font-size: 14px;
        color: #333;
        margin-right: 10px;
      }
      .value {
        font-size: 14px;
        color: #E64C5C;
      }
    }
  }
}
</style>